var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconApple = function SvgIconApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.649 0c-1.184.077-2.568.794-3.375 1.727-.735.847-1.34 2.104-1.105 3.326 1.294.038 2.631-.696 3.406-1.644.724-.884 1.272-2.133 1.074-3.409"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.328 7.045c-1.137-1.347-2.734-2.13-4.243-2.13-1.992 0-2.835.902-4.219.902-1.427 0-2.51-.9-4.233-.9-1.693 0-3.494.979-4.637 2.65C-.61 9.923-.335 14.35 2.268 18.12c.931 1.35 2.175 2.867 3.802 2.88 1.448.013 1.856-.878 3.817-.887s2.334.899 3.779.884c1.628-.011 2.94-1.693 3.871-3.042.668-.967.916-1.454 1.434-2.546-3.766-1.356-4.37-6.42-.643-8.364"
  })));
};
export default SvgIconApple;